import React, { useState } from "react";
import merntasks from "../images/merntasks.png";
import juanpablo from "../images/juanpablo.png";
import cbta from "../images/cbta.jpg";
import suneita from "../images/suneita.png";
import imgTeko from "../images/tek.png";
import portafolio from "../images/logo.png";
import veterinaria from "../images/veterinaria.png";
import producthunt from "../images/product-hunt.png";
import slick from "../images/slickapp.png";
import simon from "../images/simondice.png";

import WorksContext from "./WorksContext";

const WorksState = ({ children }) => {
  const trabajos = [
    {
      trabajoid: 10,
      img: producthunt,
      nombre: "Copia simple de Product Hunt",
      url: "https://product-hunt-5a2af.web.app",
      github: "#",
      tecnologias: [
        "HTML",
        "CSS",
        "ReactJS",
        "Next Js",
        "Firebase",
        "Styled components",
      ],
      descripcion:
        "Este proyecto es de ServerSide Rendering con Next js y usando firebase como Backend. Una copia del popular sitio Product Hunt usando la ultima versión de react",
    },
    {
      trabajoid: 9,
      img: imgTeko,
      nombre: "TEKO | Aplicación de gastos",
      url: "https://cocky-torvalds-913f94.netlify.app",
      github: "#",
      tecnologias: [
        "ReactJs",
        "Bootstrap",
        "Js",
        "Hooks",
        "MongoDB",
        "Express",
        "Node Js",
      ],
      descripcion:
        "Aplicación de gastos con las funcionalidades de creación, eliminación, actualización,obtención de gastos. En este proyecto se han puesto en practica múltiples conocimientos del stack MERN el frontend se encuentra realizadon con react con las últimas actualizaciones. Se han utilizado los Hooks useState,useReducer,useContext, useRef. También he utilizado las siguientes tenologías. React router dom, Express, Axios. He utilizado consultas a apis y en general el backend tiene el diseño Api REST. Incluye un login sencillo con cifrado de contraseñas. Existe validación por parte del frontend y del backend para que los datos sean los solicitados. Se ocupa un Json Web Token para la validación. ",
    },
    {
      trabajoid: 8,
      img: suneita,
      nombre: "SUNEITA | Tu Guia en la Universidad",
      url: "https://pensive-boyd-2dfa18.netlify.app/",
      github: "#",
      tecnologias: [
        "HTML",
        "CSS",
        "ReactJS",
        "Leaflet",
        "Nodejs",
        "Bootstrap",
        "Express",
        "Mongo DB",
        "Multer",
        "JWT",
      ],
      descripcion:
        "En este proyecto se han puesto en practica múltiples conocimientos del stack MERN el frontend se encuentra realizadon con react con las últimas actualizaciones. Se han utilizado los Hooks useState,useReducer,useContext, useRef. También he utilizado las siguientes tenologías. React router dom, Express, Axios. He utilizado consultas a apis y en general el backend tiene el diseño Api REST. Incluye un login sencillo con cifrado de contraseñas. Existe validación por parte del frontend y del backend para que los datos sean los solicitados. Se ocupa un Json Web Token para la validación.  ",
    },
    {
      trabajoid: 7,
      img: merntasks,
      nombre: "Mern Task",
      url: "https://laughing-roentgen-c54dda.netlify.app/",
      github: "#",
      tecnologias: ["HTML", "CSS", "ReactJS"],
      descripcion:
        "Esta es una aplicacion de tareas con proyectos, Esta es una aplicacion desarrollada con React, trato de llevar un código limpio y diferenciado. Separando la lógica. Uso las últimas actualizaciones de React en hooks, useState, useEffect, useReducer",
    },
    {
      trabajoid: 6,
      img: juanpablo,
      nombre: "Portafolio en Bootstrap",
      url: "https://nostalgic-jepsen-ede386.netlify.app",
      github: "#",
      tecnologias: [
        "HTML",
        "CSS",
        "ReactJS",
        "React-router",
        "React-smoth-scroll",
      ],
      descripcion:
        "Este es un portafolio básico realizado con ReactJs, bootstrap y otras tecnologías de apoyo para el enrutamiento por lo que es responsivo, simple y util. Mi intensión es mostrar que puedo maquetar sitios con el framework de Bootstrap.",
    },
    {
      trabajoid: 1,
      img: slick,
      nombre: "Slick app",
      url: "https://isaiaschavez.github.io/Slice-App/",
      github: "#",
      tecnologias: ["HTML", "CSS", "JS"],
      descripcion:
        "En este proyecto intento poner en práctica conocimientos de Js Puro, ocupo clases, funciones, arrays, funciones de arrays como map y filter. Ligo funciones para tomar en cuenta el contexto y la asincronía de Js. Estructuro el código tratando que sea claro. ",
    },
    {
      trabajoid: 2,
      img: simon,
      nombre: "Simon Dice",
      url: "https://isaiaschavez.github.io/Simon-dice/",
      github: "#",
      tecnologias: ["HTML", "CSS", "JS"],
      descripcion:
        "Este es un juego desarrollado solo con JS, el famoso juego de simon dice donde tienes que memorizar una secuencia de colores. Si te equivocas inicias de nuevo, el juego tiene un contador, animaciones modales con Sweet Alert. En este proyecto intento poner en práctica conocimientos de Js Puro, ocupo clases, funciones, arrays, funciones de arrays como map y filter. Ligo funciones para tomar en cuenta el contexto y la asincronía de Js. Estructuro el código tratando que sea claro. ",
    },
    {
      trabajoid: 3,
      img: portafolio,
      nombre: "Portafolio Personal",
      url: "https://isaiaschavez.github.io/Portafolio-Personal/",
      github: "#",
      tecnologias: ["HTML", "CSS", "JS", "PHP", "MySQL"],
      descripcion:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde nihil voluptatem, culpa aperiam, quae quas natus, ab obcaecati ea amesuscipit blanditiis quia molestias quod? Nihil consequuntur minimanobis alias. Lorem ipsum dolor sit amet consectetur adipisicing elit.Tempore voluptates possimus, similique tenetur corporis placeat aspernatur ducimus atque temporibus, iure esse illum rerum quo amet adolor velit quidem. Dicta?",
    },
    {
      trabajoid: 4,
      img: cbta,
      nombre: "Sitio web Bachillerato",
      url: "https://isaiaschavez.github.io/Sitio-web-CBTa78/",
      github: "#",
      tecnologias: ["Bootstrap"],
      descripcion:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Unde nihil voluptatem, culpa aperiam, quae quas natus, ab obcaecati ea amesuscipit blanditiis quia molestias quod? Nihil consequuntur minimanobis alias. Lorem ipsum dolor sit amet consectetur adipisicing elit.Tempore voluptates possimus, similique tenetur corporis placeat aspernatur ducimus atque temporibus, iure esse illum rerum quo amet adolor velit quidem. Dicta?",
    },
  ];

  const [worksState, setWorksState] = useState({
    trabajos,
    trabajoActivo: [
      {
        trabajoid: 0,
        urlimagen: "",
        nombre: "",
        url: "",
        tecnologias: [],
      },
    ],
  });

  const seleccionarTrabajo = (trabajoid) => {
    setWorksState({
      ...worksState,
      trabajoActivo: worksState.trabajos.filter(
        (trabajo) => trabajo.trabajoid === parseInt(trabajoid)
      ),
    });
  };

  return (
    <WorksContext.Provider
      value={{
        trabajos: worksState.trabajos,
        trabajoActivo: worksState.trabajoActivo,
        seleccionarTrabajo,
      }}
    >
      {children}
    </WorksContext.Provider>
  );
};

export default WorksState;
